import { render, staticRenderFns } from "./ShowTitleAnswer.vue?vue&type=template&id=6bf59dfc&scoped=true"
import script from "./ShowTitleAnswer.vue?vue&type=script&lang=js"
export * from "./ShowTitleAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf59dfc",
  null
  
)

export default component.exports